import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { getTimezone, setTimezone } from "reduxSlices/currentSettingsSlice"
import * as API from "services/api"
import ItemRow from "shared/ItemRow"
import { ListSelect } from "shared/selects"
import { STYLE, US_TIMEZONES } from "utils/generalSettingsHelpers"

const TimezoneSetting = () => {
  const dispatch = useDispatch()
  const timezone = useSelector(getTimezone)

  const updateTimezone = async (newTimezone) => {
    const response = await API.updateTimezoneSetting({ timezone: newTimezone })

    if (response.ok) {
      dispatch(setTimezone(newTimezone))
    } else {
      console.error("Error updating timezone: ", response);
    }
  }

  return (
    <ItemRow
      className="dark content-bar"
      itemRowHeaderContent={(
        <>
          <span className="content-bar-title">Timezone</span>
          <ListSelect
            style={STYLE}
            options={US_TIMEZONES}
            value={timezone}
            onChange={updateTimezone}
            label="select timezone"
          />
        </>
      )}
    />
  )
}

export default TimezoneSetting
